import { render } from "./header-actions.vue?vue&type=template&id=4aaec076"
import script from "./header-actions.vue?vue&type=script&setup=true&lang=js"
export * from "./header-actions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/settings/pages/users/components/header-actions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aaec076"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aaec076', __exports__)) {
    console.log('reload')
    api.reload('4aaec076', __exports__)
  }
  
  module.hot.accept("./header-actions.vue?vue&type=template&id=4aaec076", () => {
    console.log('re-render')
    api.rerender('4aaec076', render)
  })

}


export default __exports__